<template>
  <div class="main">
    <HeaderVue class="head" />
    <Sidebar class="sidebar" />
    <Dashboard title="Configurações">
      <b-row class="mb-5 justify-content-between mr-1">
        <b-col class="mb-1" cols="12" sm="8">
          <Search @changeSearchValue="searchValue = $event" />
        </b-col>
        <b-col cols="auto">
          <b-button variant="outline-secondary" @click="openModalAddUser()">
            <b-icon icon="plus-circle-fill"></b-icon> Adicionar
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mr-1">
        <b-col>
          <UsersList v-if="filteredUsers.length > 0" :users="filteredUsers" />
          <p v-else class="message-no-users-filtered mt-5">
            Não foram encontrados usuários com nome "{{ searchValue }}".
          </p>
        </b-col>
      </b-row>
      <ModalAddUser />
    </Dashboard>
  </div>
</template>

<script>
import Dashboard from '../components/Dashboard.vue';
import HeaderVue from '../components/Header.vue';
import Search from '../components/Search.vue';
import Sidebar from '../components/Sidebar.vue';
import UsersList from '../components/settings/UsersList.vue';
import ModalAddUser from '../components/settings/ModalAddUser.vue';
import { Users } from '../services/Users';

export default {
  components: {
    HeaderVue,
    Sidebar,
    Dashboard,
    Search,
    UsersList,
    ModalAddUser,
  },
  data() {
    return {
      users: [],
      filteredUsers: [],
      searchValue: '',
    };
  },
  beforeCreate() {
    Users().then((res) => {
      this.users = res.data;
      this.filteredUsers = this.users;
    });
  },
  methods: {
    openModalAddUser() {
      this.$bvModal.show('modal-add-user');
    },
  },
  watch: {
    searchValue() {
      if (this.searchValue.length === 0) this.filteredUsers = this.users;
      else {
        this.filteredUsers = this.users.filter((user) => {
          return user.name
            .toLowerCase()
            .includes(this.searchValue.toLowerCase());
        });
      }
    },
  },
};
</script>

<style scoped>
.message-no-users-filtered {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
  color: #2c2c2c;
  text-align: center;

  background-color: #d9d9d9;
  padding: 20px;
  margin-top: 20px;
  border-radius: 5px;
}
</style>
